export default class Util {}

export const FOO = "lorem ipsum";
export const BAR = "dolor sit amet";
